import { render, staticRenderFns } from "./MessageAuditGroupJoin.vue?vue&type=template&id=7d7ca13c&"
import script from "./MessageAuditGroupJoin.vue?vue&type=script&lang=js&"
export * from "./MessageAuditGroupJoin.vue?vue&type=script&lang=js&"
import style0 from "../../style.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports